// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zkLinkNova as _zkLinkNova } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zkLinkNova chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 810180
 * Chain Name: zkLink Nova
 * Default Block Explorer: https://explorer.zklink.io
 * Default RPC URL: https://rpc.zklink.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zkLinkNova } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zkLinkNova,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zkLinkNova = createCommon({
	..._zkLinkNova,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
